import Vue from 'vue'
import VueResource from 'vue-resource'
import { sync } from 'vuex-router-sync'
import * as env from './env'
import * as config from './config'
import AsyncComputed from 'vue-async-computed'
import router from './router'
import store from './store'
import filters from './filters'
import mixin from './mixin'
import App from './App'
import VueAnalytics from 'vue-analytics'
// Components import
import Tooltip from 'vue-directive-tooltip'
import VueEsc from 'vue-esc'
import VueCookie from 'vue-cookie'

// Tell Vue to use the plugin
// Vue plugins configuration
Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(AsyncComputed)
Vue.use(Tooltip)
Vue.use(VueEsc)

let idGA = 'UA-135025349-1'
if (process.env.NODE_ENV !== 'production') {
  idGA = 'UA-135025349-4'
}
Vue.use(VueAnalytics, {
  id: idGA,
  router,
  autoTracking: {
    page: true
  }
})

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)

// Components
Vue.component('app', App)

import FormLogin from './components/forms/FormLogin'
import FormRegistration from './components/forms/FormRegistration'
import FormSearchCities from './components/forms/FormSearchCities.vue'
import FormNewsletter from './components/forms/FormNewsletter'
import FormSearchSkus from './components/forms/FormSearchSkus'
import InputCep from './components/forms/inputs/InputCep'
import InputStates from './components/forms/inputs/InputStates'
import InputCities from './components/forms/inputs/InputCities'
import InputNeighborhoods from './components/forms/inputs/InputNeighborhoods'
import InputNumber from './components/forms/inputs/InputNumber'
import InputSelect from './components/forms/inputs/InputSelect'
import InputText from './components/forms/inputs/InputText'
import InputPhone from './components/forms/inputs/InputPhone'
import InputTextarea from './components/forms/inputs/InputTextarea'
import InputDate from './components/forms/inputs/InputDate'
import InputEmail from './components/forms/inputs/InputEmail'
import InputPassword from './components/forms/inputs/InputPassword'
import InputFile from './components/forms/inputs/InputFile'
import PaginationBootstrap from './components/bootstrap/PaginationBootstrap'
import ModalBootstrap from './components/bootstrap/ModalBootstrap'
import Loading from './components/app/Loading'
import MktpRentStatus from './components/app/MktpRentStatus'
import {buttonGroup, radio, typeahead, tabs, tabGroup, tab, carousel, slider} from 'vue-strap'

Vue.component('form-login', FormLogin)
Vue.component('form-registration', FormRegistration)
Vue.component('form-search-cities', FormSearchCities)
Vue.component('form-newsletter', FormNewsletter)
Vue.component('form-search-skus', FormSearchSkus)
Vue.component('tabs', tabs)
Vue.component('tabGroup', tabGroup)
Vue.component('tab', tab)
Vue.component('typeahead', typeahead)
Vue.component('radio', radio)
Vue.component('button-group', buttonGroup)
Vue.component('carousel', carousel)
Vue.component('slider', slider)
Vue.component('input-cep', InputCep)
Vue.component('input-states', InputStates)
Vue.component('input-cities', InputCities)
Vue.component('input-neighborhoods', InputNeighborhoods)
Vue.component('input-number', InputNumber)
Vue.component('input-select', InputSelect)
Vue.component('input-text', InputText)
Vue.component('input-phone', InputPhone)
Vue.component('input-textarea', InputTextarea)
Vue.component('input-date', InputDate)
Vue.component('input-email', InputEmail)
Vue.component('input-password', InputPassword)
Vue.component('input-file', InputFile)
Vue.component('pagination-bootstrap', PaginationBootstrap)
Vue.component('modal-bootstrap', ModalBootstrap)
Vue.component('loading', Loading)
Vue.component('mktp-rent-status', MktpRentStatus)

sync(store, router)

Vue.http.options.root = config.apiURL
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Accept', 'application/json')
  if (store.state.user.access_token) {
    request.headers.set('Authorization', 'Bearer ' + store.state.user.access_token)
    request.headers.set('ClientId', env.clientId)
  }
  next((response) => {
    if (response.status === 401) {
      store.commit('UNSET_USER')
      if (!['login', 'sku', 'sku_checkout', 'company_registration'].includes(router.history.current.name)) {
        router.push({name: 'login'})
      }
    }
  })
})

Vue.config.keyCodes = {
  'enter': [13],
  'arrow-keys': [37, 38, 39, 40],
  'arrow-vertical-keys': [38, 40],
  'arrow-horizontal-keys': [37, 39]
}

new Vue({
  router,
  store,
  filters,
  mixin
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js